import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from 'reactstrap';
import PageMeta from 'components/PageMeta';
import OptInFormInfographic from 'components/OptInFormInfographic';
import Header from 'components/Elements/Header';
import Footer from 'components/Elements/Footer';

export default function InfographicIndex(props) {
  const shareUrl = 'https://brain.foodrevolution.org/discover/';
  const shareImg = 'https://cdn.foodrevolution.org/hbc/og/hbc-open-graph-20200903-evergreen-infographic-fbt.jpg';
  const facebookDescription =
    'How you choose to fuel your brain can be the difference between a clear and healthy mind or a foggy and forgetful mind. Learn the best and worst foods for brain health today in this FREE printable poster.';
  const twitterDescription =
    'Clear and healthy mind or foggy and forgetful mind? The choice is yours. #BrainBreakthroughs Get your FREE printable poster to learn the best and worst foods for brain health:';
  const pinterestDescription =
    'Your brain is hungry. How you chose to fuel it can be the difference between a clear and healthy mind or a foggy and forgetful mind. Get your FREE printable poster today to learn the best and worst foods for brain health:';
  const pinterestImg =
    'https://cdn.foodrevolution.org/hbc/og/hbc-open-graph-20200903-evergreen-infographic-pinterest.jpg';

  return (
    <>
      <PageMeta
        url={shareUrl}
        title="Get your FREE printable poster now."
        description="Learn the top 12 best foods to eat and 10 to avoid for lasting brain health."
        ogImage={shareImg}
      />

      <Header
        bgColor="purple"
        lockupWhite
        shareUrl={shareUrl}
        shareImg={shareImg}
        facebookDescription={facebookDescription}
        twitterDescription={twitterDescription}
        pinterestDescription={pinterestDescription}
        pinterestImg={pinterestImg}
      />
      <div className="infographic-optin-mobile-layout background-image-blueberries-avocados background-image-center background-cover background-overlay-black-90 background-fixed py-5 text-white text-center">
        <Container>
          <Row className="justify-content-center">
            <Col xs="7" sm="5" md="4" className="mb-4">
              <img
                className="rounded-circle"
                src="https://cdn.foodrevolution.org/hbc/speaker/dean-ayesha-116-crop-square.jpg"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <h4 className="section-heading">
                Discover Drs. Dean and Ayesha <br className="d-none d-sm-block d-lg-none" />
                Sherzai’s <br className="d-none d-lg-block" />
                <em>
                  Top 10 Foods To Eat & <br className="d-none d-sm-block d-lg-none" />
                  Avoid For Brain Health
                </em>
              </h4>
              <p>
                How you fuel your brain can nourish a clear mind <br className="d-none d-sm-block" />
                and strong memory — or brain fog and dementia.
              </p>
              <p className="mb-0">
                Enter your information below to get this FREE <br className="d-none d-sm-block d-lg-none" />
                handy poster that <br className="d-none d-lg-block" />
                you can even print and put <br className="d-none d-sm-block d-lg-none" />
                on your fridge — so you never forget!
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="background-white py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg="10">
              <OptInFormInfographic
                linkColor="black"
                textAction={
                  <>
                    PLUS: Put it into action by joining the <br className="d-none d-md-block" />
                    Brain Breakthroughs Masterclass on the next page!
                  </>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footer-content mt-auto mt-lg-0">
        <Footer />
      </div>
    </>
  );
}
